<!-- 发送聊天组件 -->
<template>
  <div class="chat-card-box">
    <div class="chat-card">
      <div class="chat-text">
        {{ cardData.text }}
      </div>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>

export default {
  name: 'ChatText',
  components: {
  },
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.chat-card-box {
  text-align: right;
}
.chat-card {
  max-width: 269px;
  display: inline-block;
  border-radius: 12px 12px 0px 12px;
  padding: 10px 13px 10px 15px;
  background: #DAF6F4;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
    text-align: left;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
</style>
